import { Gantt } from "wx-react-gantt";
import "wx-react-gantt/dist/gantt.css";
import React, { useRef, useEffect } from "react";
import { Willow } from "wx-react-gantt";
import "wx-react-gantt/dist/gantt.css"; //import theme

const Toyota_Gantt = () => {
    const start_date = new Date(2025, 2, 2);

    const addDays = (days) => {
        const newDate = new Date(start_date);
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    }

    const markers = [
        {
            start: addDays(20),
            text: "Setup",
        },
        {
            start: addDays(180),
            text: "Module 1",
        },
        {
            start: addDays(50),
            text: "Checkpoint [1]",
        },
        {
            start: addDays(80),
            text: "Checkpoint [2]",
        },
        {
            start: addDays(110),
            text: "Checkpoint [3]",
        },
        {
            start: addDays(140),
            text: "Checkpoint [4]",
        },
        {
            start: addDays(210),
            text: "Checkpoint [5]",
        },
    ];

    const tasks = [
        {
            id: "INF",
            text: "Infrastructure",
            progress: 0,
            type: "summary",
            open: true
        },
        {
            id: "INF.CHECK",
            text: "Infrastructure check",
            start: addDays(30),
            end: addDays(32),
            type: "milestone",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.SERVER",
            text: "App Cloud setup",
            start: addDays(0),
            end: addDays(7),
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.API",
            text: "API setup",
            start: addDays(7),
            end: addDays(15),
            progress: 2,
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.UI",
            text: "UI setup",
            start: addDays(7),
            end: addDays(15),            
            progress: 2,
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.DB",
            text: "DB setup",
            start: addDays(7),
            end: addDays(15),
            progress: 2,
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.SEMDB",
            text: "Vector db setup",
            start: addDays(7),
            end: addDays(20),
            progress: 2,
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "INF.APP.ACCESS",
            text: "App main configuration",
            start: addDays(18),
            end: addDays(30),
            progress: 2,
            type: "task",
            lazy: false,
            parent: "INF"
        },
        {
            id: "ESG",
            text: "Modulo 1",
            progress: 0,
            type: "summary",
            open: true
        },
        {
            id: "ESG.USERS",
            text: "Users and security",
            progress: 75,
            start: addDays(0),
            end: addDays(25),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.DMS",
            text: "DMS",
            progress: 75,
            start: addDays(0),
            end: addDays(45),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.BFM",
            text: "BFM",
            progress: 25,
            start: addDays(45),
            end: addDays(120),
            type: "task",
            lazy: false,
            parent: "ESG",
            open: true
        },
        {
            id: "ESG.QUEUE",
            text: "QUEUE MANAGER",
            progress: 25,
            start: addDays(80),
            end: addDays(120),
            type: "task",
            lazy: false,
            parent: "ESG.BFM"
        },
        {
            id: "ORG.CHART",
            text: "Organizational chart",
            start: addDays(0),
            progress: 80,
            end: addDays(15),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "FUNCT.CHART",
            text: "Functional chart",
            progress: 80,
            start: addDays(15),
            end: addDays(30),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.REQ",
            text: "Requisites editor",
            progress: 80,
            start: addDays(30),
            end: addDays(40),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.IND",
            text: "Indicators editor",
            progress: 50,
            start: addDays(40),
            end: addDays(50),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.ACT",
            text: "Activities manager",
            start: addDays(50),
            end: addDays(75),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.CHATBOT",
            text: "Chatbot v.1",
            progress: 80,
            start: addDays(20),
            end: addDays(50),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.VECT",
            text: "Vector LTM",
            start: addDays(75),
            end: addDays(100),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.VECT.CHATBOT",
            text: "LTM Vector Chatbot v.2",
            start: addDays(100),
            end: addDays(125),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.FORUM",
            text: "Forum and community",
            start: addDays(125),
            end: addDays(145),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.VECT.CHATBOT",
            text: "AI Vector/Similarity check",
            start: addDays(130),
            end: addDays(140),
            type: "milestone",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.MAPS",
            text: "Maps data viewer",
            start: addDays(125),
            end: addDays(145),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.SURVEYS",
            text: "Surveys generator",
            start: addDays(145),
            end: addDays(165),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.NOT",
            text: "Notification system",
            start: addDays(160),
            end: addDays(180),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "ESG.DMS.FLOW",
            text: "Dms base flow check",
            start: addDays(45),
            end: addDays(60),
            type: "milestone",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "POWERBI.INT",
            text: "PowerBI integration",
            start: addDays(50),
            end: addDays(75),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "POWERBI.INT.CHECK",
            text: "Report generation check",
            start: addDays(90),
            end: addDays(100),
            type: "milestone",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "AI.DOC.GENERATOR",
            text: "AI document generator",
            start: addDays(75),
            end: addDays(100),
            type: "task",
            lazy: false,
            parent: "ESG"
        },
        {
            id: "DEPLOY",
            text: "Module 2-3",
            progress: 0,
            type: "summary",
            open: true
        },
        {
            id: "DEPLOY.SEGR",
            text: "Data segregation",
            start: addDays(180),
            end: addDays(245),
            type: "task",
            lazy: false,
            parent: "DEPLOY"
        },       
        {
            id: "DEPLOY.CRIPTO",
            text: "Data criptography",
            start: addDays(245),
            end: addDays(305),
            type: "task",
            lazy: false,
            parent: "DEPLOY"
        },
        {
            id: "DEPLOY.SEGR.ASS",
            text: "Security assessment",
            start: addDays(315),
            end: addDays(345),
            type: "milestone",
            lazy: false,
            parent: "DEPLOY"
        },
        {
            id: "DEPLOY.LOCAL.CUST",
            text: "Dealers/Local customization",
            start: addDays(305),
            end: addDays(350),
            type: "task",
            lazy: false,
            parent: "DEPLOY"
        },
        {
            id: "PRODUCTION",
            text: "Production GO-LIVE",
            progress: 0,
            type: "summary",
            open: true
        },
        {
            id: "PRODUCTION.SERVERS",
            text: "Production servers setup",
            start: addDays(275),
            end: addDays(300),
            type: "task",
            lazy: false,
            parent: "PRODUCTION"
        },     
        {
            id: "PRODUCTION.AI",
            text: "Production AI setup",
            start: addDays(275),
            end: addDays(330),
            type: "task",
            lazy: false,
            parent: "PRODUCTION"
        },     
        {
            id: "PRODUCTION.FINAL",
            text: "Final GO-LIVE",
            start: addDays(330),
            end: addDays(366),
            type: "milestone",
            lazy: false,
            parent: "PRODUCTION"
        },     
        // {
        //     id: 20,
        //     text: "New Task",
        //     start: new Date(2024, 5, 11),
        //     end: new Date(2024, 6, 12),
        //     duration: 1,
        //     progress: 2,
        //     type: "task",
        //     lazy: false,
        // },
        // {
        //     id: 47,
        //     text: "[1] Master project",
        //     start: new Date(2024, 5, 12),
        //     end: new Date(2024, 7, 12),
        //     duration: 8,
        //     progress: 0,
        //     parent: 0,
        //     type: "summary",
        // },
        // {
        //     id: 22,
        //     text: "Task",
        //     start: new Date(2024, 7, 11),
        //     end: new Date(2024, 8, 12),
        //     duration: 8,
        //     progress: 0,
        //     parent: 47,
        //     type: "task",
        // },
        // {
        //     id: 21,
        //     text: "New Task 2",
        //     start: new Date(2024, 7, 10),
        //     end: new Date(2024, 8, 12),
        //     duration: 3,
        //     progress: 0,
        //     type: "task",
        //     lazy: false,
        // },
    ];

    const links = [{ id: 1, source: 20, target: 21, type: "e2e" }];

    const scales = [
        { unit: "month", step: 1, format: "MMMM yyy" },
        { unit: "day", step: 7, format: "d" },
    ];

    return (<Willow><Gantt tasks={tasks} links={links} scales={scales} cellWidth={10} markers={markers} /></Willow>);
};

export default Toyota_Gantt;